import "./greeting_page.css";
import intro_bg from "../../img/intro_bg.jpg";

function GreetingPage() {
  const words = `
가정에 평안과 행복이 가득하시길 기원합니다.

고령화 시대, 노인성 질환으로 어려움을 겪고 계시는지요?
그로인해 생업에 지장을 받으시나요?
사랑하는 가족을 믿고 맡길 수 있는 기관을 찾고 계신가요?
우리 '시니어사랑방문요양센터'에서 알려드립니다.

1.사랑으로 섬김을 실천하는 기관

2.낮은 자세로 섬김을 실천하는 기관

3.전문적인 소양을 갖춘 기관

4.투명하고 깨끗한 기관

약속드리는 바 어르신들의 인권을 가장 우선시하는 기관으로,
지역사회와 더불어 행복한 공동체를 이루기 위해 부단히 노력하는 기관이 되겠습니다.

누구나 경제적인 불평등 없이 전문적인 케어를 누릴 수 있는 권리,
가족구성원은 생업에 더욱 집중할 수 있는 기회를 우리 센터와 함께 동행 해 보심은 어떠하신가요?

`;

  return (
    <div className="greeting_page">
      <img src={intro_bg} />
      <div className="greeting_container">
        <div className="greeting_words">
          시니어사랑방문요양센터에 오신 것을 진심으로 환영합니다.
        </div>
        {words}
        <div className="writer_name">대표 김지형 배상</div>
      </div>
    </div>
  );
}

export default GreetingPage;
